import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { queryClient } from 'providers';

import { CMSApiService } from '../api/cms-api.service';
import { eventsQueryKeys } from './query-keys';

const { createRacekit } = CMSApiService();

export const useCreateRacekit = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return createRacekit(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (data) => {
                const { ResponseMessage } = data;
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (data.ResponseStatus == 0) {
                    message.error(ResponseMessage)
                } else {
                    message.success("RaceKit  added successfully");
                }
            },
        },
    );
};
